export default __webpack_public_path__ + "static/media/invenotryGirlAF.96adab99.png";